import {
    formatAppointmentDateTime,
    formatPatientName,
    getRowKey,
} from '../../cancellation-followups/subparts/cancellationFollowupChannel';

export const THANK_YOU_CHANNELS = [
    { key: 'email', label: 'Email', enabledKey: 'isEmail', contactKey: 'email', selectedKey: 'isEmailSelected' },
    { key: 'sms', label: 'SMS', enabledKey: 'isSms', contactKey: 'cellPhone', selectedKey: 'isSmsSelected' },
];

const hasContact = (record, channel) => Boolean(record?.[channel.contactKey]?.trim());

export const resolvePreferredChannel = (record) => {
    if (record?.isEmailSelected) {
        return 'email';
    }

    if (record?.isSmsSelected) {
        return 'sms';
    }

    return null;
};

export const getChannelState = (record, channelKey) => {
    const channel = THANK_YOU_CHANNELS.find((item) => item.key === channelKey);
    if (!channel) {
        return { available: false, enabled: false, disabled: true };
    }

    const available = hasContact(record, channel);
    const thankYouEnabled = record?.isThankyou !== false;
    const channelEnabled = record?.[channel.enabledKey] !== false;
    const disabled = !available || !thankYouEnabled || !channelEnabled;

    return { available, enabled: thankYouEnabled && channelEnabled, disabled };
};

export const buildDefaultChannelSelection = (record) => {
    const preferred = resolvePreferredChannel(record);

    if (preferred && !getChannelState(record, preferred).disabled) {
        return preferred;
    }

    const fallback = THANK_YOU_CHANNELS.find((channel) => !getChannelState(record, channel.key).disabled);
    return fallback?.key ?? null;
};

export const getRowChannelSelection = (channelSelections, rowKey, record) =>
    channelSelections[rowKey] ?? buildDefaultChannelSelection(record);

export const isRowSendable = (record) => {
    if (record?.isThankyou === false) {
        return false;
    }

    return THANK_YOU_CHANNELS.some((channel) => !getChannelState(record, channel.key).disabled);
};

export const DEFAULT_THANK_YOU_REMINDER_TYPE = 'THANK_YOU';

export const buildThankYouSendJobs = (records, selectedRowKeys, channelSelections) => {
    const jobs = [];

    records.forEach((record) => {
        const rowKey = getRowKey(record);

        if (!selectedRowKeys.has(rowKey)) {
            return;
        }

        const selectedChannel = getRowChannelSelection(channelSelections, rowKey, record);
        if (!selectedChannel) {
            return;
        }

        const state = getChannelState(record, selectedChannel);
        if (state.disabled) {
            return;
        }

        jobs.push({
            patientId: record.id,
            appointmentId: record.appointmentId,
            mediumType: selectedChannel === 'sms' ? 'SMS' : 'EMAIL',
            patientName: formatPatientName(record),
        });
    });

    return jobs;
};

export const getSendableRowKeys = (records) =>
    records.filter(isRowSendable).map((record) => getRowKey(record));

export { formatAppointmentDateTime, formatPatientName, getRowKey };
